<template>
  <div class="body1" v-loading="isLoading">
    <!-- 课程数据 -->
    <div class="left">
      <div class="top">
        <div class="titleBox" style="justify-content: space-between">
          <div class="title">基础概况</div>
        </div>
        <div class="dataBox">
          <div class="info_box">
            <div class="info blueBG">
              <span>教师总数</span>
              <span>{{ teacherCount }}</span>
            </div>
            <div class="info blueBG">
              <span>考核项目总数</span>
              <span>{{ 6 }}</span>
            </div>
            <div class="info blueBG">
              <span>提交人数</span>
              <span>{{ submitPCount }}</span>
            </div>
            <div class="info blueBG">
              <span>数据总数</span>
              <span>{{ submitCount }}</span>
            </div>
          </div>
          <div class="depth_box" style="height: calc(100% - 140px)">
            <div class="depth">
              <span>考核项目完成率</span>
              <div>
                <el-progress :width="100" type="circle"
                  :percentage="subPersent ? parseInt((subPersent / teacherCount * 100).toFixed(0)) : 0" :stroke-width="15"
                  :format="format" color="#106BFF"></el-progress>
              </div>
            </div>
            <div class="depth">
              <span>教师项目提交率</span>
              <div>
                <el-progress :width="100" type="circle"
                  :percentage="subPersent2 ? parseInt((subPersent2 / teacherCount * 100).toFixed(0)) : 0"
                  :stroke-width="15" :format="format" color="#106BFF"></el-progress>
              </div>
            </div>
          </div>
          <!-- <div style="height: calc(100% - 140px)">
            <TeaFre style="height: calc(100%)" :monthArray="loginCountMonthArray"></TeaFre>
          </div> -->
        </div>
      </div>
      <div class="bottom">
        <div class="titleBox">
          <div class="title">
            培训心得
          </div>
        </div>

        <div class="dataBox">
          <div class="info_box" style="width: 96%">
            <div class="info blueBG">
              <span>提交总数</span>
              <span>{{ xindeCount }}</span>
            </div>
            <div class="info blueBG">
              <span>人均提交次数</span>
              <span>{{ xindeCount ? (xindeCount / teacherCount).toFixed(0) : 0 }}</span>
            </div>
          </div>
          <Bar style="height: calc(100% - 70px)" :workList="tedurArray"></Bar>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="top">
        <div class="titleBox" style="justify-content: space-between">
          <div class="title">
            教学设计
          </div>
          <el-select v-model="cType" @change="typeChange1" class="selectBox" style="width:205px">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in shejiTime" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="dataBox">
          <div class="info_box" style="width: 96%">
            <div class="info blueBG">
              <span>提交总数</span>
              <span>{{ shejiCount }}</span>
            </div>
            <div class="info blueBG">
              <span>提交人数</span>
              <span>{{ shejiPCount }}</span>
            </div>
          </div>
          <CateRank style="height:calc(100% - 70px);" :courseArray="courseArray"></CateRank>
        </div>
      </div>
      <div class="bottom">
        <div class="titleBox" style="justify-content: space-between">
          <div class="title">教师活动</div>
        </div>
        <div class="dataBox">
          <div class="info_box">
            <div class="info blueBG" style="width: calc(100% / 3 - 10px)">
              <span>提交总数</span>
              <span>{{ guihuaArray.length + guanshuArray.length }}</span>
            </div>
            <div class="info blueBG" style="width: calc(100% / 3 - 10px)">
              <span>发展规划提交总数</span>
              <span>{{ guihuaArray.length }}</span>
            </div>
            <div class="info blueBG" style="width: calc(100% / 3 - 10px)">
              <span>教育观树提交总数</span>
              <span>{{ guanshuArray.length }}</span>
            </div>
          </div>
          <WorkNum style="height: calc(100% - 70px)" :workNumList="workNumList">
          </WorkNum>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="top" style="border-radius: 5px">
        <div class="titleBox" style="justify-content: space-between">
          <div style="
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
            ">
            <div class="title" :class="{ isClick: toolType == 0 }" @click="toolType = 0"
              style="cursor: pointer; padding: 0 0 5px 0">
              获奖级别
            </div>
            <div class="title" :class="{ isClick: toolType == 1 }" @click="toolType = 1"
              style="cursor: pointer; padding: 0 0 5px 0">
              获奖名次
            </div>
          </div>
          <el-select v-model="cType2" @change="typeChange2" class="selectBox" v-if="toolType == 0" style="width:205px">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in timeXuan" :key="item" :label="item" :value="item"></el-option>
          </el-select>
          <el-select v-model="cType3" @change="typeChange3" class="selectBox" v-if="toolType == 1" style="width:205px">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in timeXuan" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="dataBox">
          <div class="info_box" v-if="toolType == 0">
            <div class="info blueBG">
              <span>获奖总数</span>
              <span>{{ huojiangCont }}</span>
            </div>
            <div class="info blueBG">
              <span>获奖人数</span>
              <span>{{ huojiangPCont }}</span>
            </div>
          </div>
          <CourseAna style="height: calc(100% - 70px)" :courseNumberArray="courseNumberArray" v-if="toolType == 0">
          </CourseAna>
          <ToolChart style="height: calc(100%)" :toolArray="toolList" v-if="toolType == 1"></ToolChart>
        </div>
      </div>
      <div class="bottom">
        <div class="titleBox" style="justify-content: space-between">
          <div class="title">德育获奖</div>
          <el-select v-model="cType4" @change="typeChange4" class="selectBox" style="width:205px">
            <el-option label="全部" value=""></el-option>
            <el-option v-for="item in deyuTimeXuan" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
        <div class="dataBox">
          <div class="info_box">
            <div class="info blueBG">
              <span>获奖总数</span>
              <span>{{ deyuCont }}</span>
            </div>
            <div class="info blueBG">
              <span>获奖人数</span>
              <span>{{ deyuPCont }}</span>
            </div>
          </div>
          <!-- personList -->
          <WorkTime style="height: calc(100% - 70px)" :toolArray="personList"></WorkTime>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TeaFre from "./chartList/teaFre.vue";
import ToolUse from "./chartList/toolUse.vue";
import ToolUse2 from "./chartList/toolUse2.vue";
import CateRank from "./chartList/cateRank.vue";
import WorkNum from "./chartList/workNum.vue";
import CourseTime from "./chartList/courseTime.vue";
import CourseAna from "./chartList/courseAna.vue";
import WorkTime from "./chartList/workTime.vue";
import Bar from "./chartList/bar.vue";
import Bar2 from "./chartList/bar2.vue";
import CourseNum from "./chartList/courseNum.vue";
import ToolChart from "./chartList/toolChart.vue";
import Subjuect from "./chartList/subjuect.vue";
export default {
  components: {
    TeaFre,
    ToolUse,
    ToolUse2,
    CateRank,
    WorkNum,
    CourseTime,
    CourseAna,
    WorkTime,
    Bar,
    Bar2,
    CourseNum,
    ToolChart,
    Subjuect,
  },
  props: {
    oid: {
      type: String,
    },
    org: {
      type: String,
    },
  },
  data() {
    return {
      isLoading: false,
      cType: "",
      cType2: "",
      cType3: "",
      cType4: "",
      cType7: "全部课程",
      toolType: 0,
      tType: 0,
      skType: 0,
      courseType: 0,
      sType: 0,
      oType: false,
      oType2: false,
      shType: true,
      xtType: false,
      allCourse: 0,
      courseTemplate: 0,
      loginCountMonthArray: [],
      lType: "grade",
      lType1: "grade",
      allTimeList: [],
      tedurArray: [],
      tedurArray2: [],
      classList: [],
      subjectList: [],
      themeList: [],
      teacherCount: 0,
      testCount: 0,
      submitPCount: 0,
      submitCount: 0,
      courseWorksCountYearArray: [],
      courseNumberArray: {},
      toolList: {},
      personList: {},
      workNumList: {},
      courseArray: {},
      subPersent: 0,
      subPersent2: 0,
      xindeCount: 0,
      shejiCount: 0,
      shejiPCount: 0,
      shejiArray: [],
      shejiTime: [],
      shejiXuan: [],
      shejiTong: {},
      guihuaArray: [],
      guanshuArray: [],
      huojiangArray: [],
      timeXuan: [],
      jibieXuan: [],
      mingciXuan: [],
      deyuArray: [],
      deyuTimeXuan: [],
      deyuJibieXuan: [],
      huojiangCont: 0,
      huojiangPCont: 0,
      deyuCont: 0,
      deyuPCont: 0,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    openCourse(cid) {
      window.parent.postMessage({ cid: cid, screenType: "3" }, "*");
    },
    otherEchart() {
      this.oType = !this.oType;
    },
    otherEchart2() {
      this.oType2 = !this.oType2;
    },
    shEchart() {
      this.shType = !this.shType;
    },
    xtEchart() {
      this.xtType = !this.xtType;
    },
    format(percentage) {
      return percentage + "%";
    },
    getMonth() {
      // 获取当前时间
      var currentDate = new Date();

      // 获取本月的年份和月份
      var currentYear = currentDate.getFullYear();
      var currentMonth = currentDate.getMonth() + 1; // 月份从0开始，需要加1

      // 获取上个月的年份和月份
      var lastMonthYear, lastMonth;
      if (currentMonth === 1) {
        lastMonthYear = currentYear - 1;
        lastMonth = 12;
      } else {
        lastMonthYear = currentYear;
        lastMonth = currentMonth - 1;
      }
      // 获取本月的第一天和最后一天的日期
      var firstDayOfMonth = new Date(currentYear, currentMonth - 1, 1);
      var lastDayOfMonth = new Date(currentYear, currentMonth, 0);

      // 获取上个月的第一天和最后一天的日期
      var firstDayOfLastMonth = new Date(lastMonthYear, lastMonth - 1, 1);
      var lastDayOfLastMonth = new Date(lastMonthYear, lastMonth, 0);

      // 构建本月日期的数组
      var currentMonthDates = [];
      for (var i = 1; i <= lastDayOfMonth.getDate(); i++) {
        let a = new Date(currentYear, currentMonth - 1, i)
        currentMonthDates.push(a.getFullYear() + '-' + (a.getMonth() + 1) + '-' + a.getDate());
      }

      // 构建上个月日期的数组
      var lastMonthDates = [];
      for (var j = firstDayOfLastMonth.getDate(); j <= lastDayOfLastMonth.getDate(); j++) {
        let a = new Date(lastMonthYear, lastMonth - 1, j)
        lastMonthDates.push(a.getFullYear() + '-' + (a.getMonth() + 1) + '-' + a.getDate());
      }

      return {
        lastWeek: lastMonthDates,//上月
        toWeek: currentMonthDates //本月
      }
    },
    typeChange1() {
      let shejiArray = this.shejiArray;
      var shejiTong = {};
      let shejiCount = {}
      let shejiPCount = {}
      shejiTong[''] = {}
      shejiCount[''] = 0
      shejiPCount[''] = []
      for (var i = 0; i < this.shejiTime.length; i++) {
        shejiTong[this.shejiTime[i]] = {}
        shejiCount[this.shejiTime[i]] = 0
        shejiPCount[this.shejiTime[i]] = []
        for (var j = 0; j < this.shejiXuan.length; j++) {
          shejiTong[this.shejiTime[i]][this.shejiXuan[j]] = 0
          shejiTong[''][this.shejiXuan[j]] = 0
        }
      }
      for (var i = 0; i < shejiArray.length; i++) {
        let shejiJson = JSON.parse(shejiArray[i].courseJson)
        if(shejiJson[0] && shejiJson[0].array){
          shejiJson = shejiJson[0].array
        }
        let xuanTime = shejiJson[1].json.answer2
        let xuanXuan = shejiJson[2].json.answer2
        for (var j = 0; j < xuanTime.length; j++) {
          shejiCount[this.shejiTime[xuanTime[j]]]++
          shejiPCount[this.shejiTime[xuanTime[j]]].indexOf(shejiArray[i].userid) == -1 ? shejiPCount[this.shejiTime[xuanTime[j]]].push(shejiArray[i].userid) : ''
          for (var z = 0; z < xuanXuan.length; z++) {
            shejiTong[this.shejiTime[xuanTime[j]]][this.shejiXuan[xuanXuan[z]]]++
            shejiTong[''][this.shejiXuan[xuanXuan[z]]]++
          }
        }

        shejiCount['']++
        shejiPCount[''].indexOf(shejiArray[i].userid) == -1 ? shejiPCount[''].push(shejiArray[i].userid) : ''
      }
      this.courseArray = shejiTong[this.cType]
      this.shejiCount = shejiCount[this.cType];
      this.shejiPCount = shejiPCount[this.cType].length;
      this.$forceUpdate();
    },
    typeChange2() {
      let huojiangArray = this.huojiangArray;
      var jibieTong = {};
      var personTong = {};
      jibieTong[''] = {};
      personTong[''] = [];
      for (var i = 0; i < this.timeXuan.length; i++) {
        jibieTong[this.timeXuan[i]] = {}
        personTong[this.timeXuan[i]] = []
        for (var j = 0; j < this.jibieXuan.length; j++) {
          jibieTong[this.timeXuan[i]][this.jibieXuan[j]] = 0
          jibieTong[''][this.jibieXuan[j]] = 0
        }
      }
      for (var i = 0; i < huojiangArray.length; i++) {
        let Json = JSON.parse(huojiangArray[i].courseJson)
        let xuanTime = Json[0].json.answer2
        let xuanXuan = Json[2].json.answer2
        console.log(xuanXuan);
        for (var j = 0; j < xuanTime.length; j++) {
          if (personTong[this.timeXuan[xuanTime[j]]].indexOf(huojiangArray[i].userid) == -1) {
            personTong[this.timeXuan[xuanTime[j]]].push(huojiangArray[i].userid)
          }
          for (var z = 0; z < xuanXuan.length; z++) {
            jibieTong[this.timeXuan[xuanTime[j]]][this.jibieXuan[xuanXuan[z]]]++
            jibieTong[''][this.jibieXuan[xuanXuan[z]]]++
          }
        }
        if (personTong[''].indexOf(huojiangArray[i].userid) == -1) {
          personTong[''].push(huojiangArray[i].userid)
        }
      }
      var a = Object.keys(jibieTong[this.cType2])
      let huojiangCont = 0
      let huojiangPCont = personTong[this.cType2].length
      for (var i = 0; i < a.length; i++) {
        huojiangCont += jibieTong[this.cType2][a[i]]
      }
      this.huojiangCont = huojiangCont
      this.huojiangPCont = huojiangPCont
      this.courseNumberArray = jibieTong[this.cType2]
      this.$forceUpdate();
    },
    typeChange3() {
      let huojiangArray = this.huojiangArray;
      var jibieTong = {};
      jibieTong[''] = {}
      for (var i = 0; i < this.timeXuan.length; i++) {
        jibieTong[this.timeXuan[i]] = {}
        for (var j = 0; j < this.mingciXuan.length; j++) {
          jibieTong[this.timeXuan[i]][this.mingciXuan[j]] = 0
          jibieTong[''][this.mingciXuan[j]] = 0
        }
      }

      for (var i = 0; i < huojiangArray.length; i++) {
        let Json = JSON.parse(huojiangArray[i].courseJson)
        let xuanTime = Json[0].json.answer2
        let xuanXuan = Json[3].json.answer2
        console.log(xuanXuan);

        for (var j = 0; j < xuanTime.length; j++) {
          for (var z = 0; z < xuanXuan.length; z++) {
            jibieTong[this.timeXuan[xuanTime[j]]][this.mingciXuan[xuanXuan[z]]]++
            jibieTong[''][this.mingciXuan[xuanXuan[z]]]++
          }
        }
      }
      this.toolList = jibieTong[this.cType3]
      this.$forceUpdate();
    },
    typeChange4() {
      let deyuArray = this.deyuArray;
      var jibieTong = {};
      var personTong = {};
      jibieTong[''] = {}
      personTong[''] = []
      for (var i = 0; i < this.deyuTimeXuan.length; i++) {
        jibieTong[this.deyuTimeXuan[i]] = {}
        personTong[this.deyuTimeXuan[i]] = []
        for (var j = 0; j < this.deyuJibieXuan.length; j++) {
          jibieTong[this.deyuTimeXuan[i]][this.deyuJibieXuan[j]] = 0
          jibieTong[''][this.deyuJibieXuan[j]] = 0
        }
      }

      for (var i = 0; i < deyuArray.length; i++) {
        let Json = JSON.parse(deyuArray[i].courseJson)
        let xuanTime = Json[0].json.answer2
        let xuanXuan = Json[3].json.answer2
        console.log(xuanXuan);

        for (var j = 0; j < xuanTime.length; j++) {
          if (personTong[this.deyuTimeXuan[xuanTime[j]]].indexOf(deyuArray[i].userid) == -1) {
            personTong[this.deyuTimeXuan[xuanTime[j]]].push(deyuArray[i].userid)
          }
          for (var z = 0; z < xuanXuan.length; z++) {
            jibieTong[this.deyuTimeXuan[xuanTime[j]]][this.deyuJibieXuan[xuanXuan[z]]]++
            jibieTong[''][this.deyuJibieXuan[xuanXuan[z]]]++
          }
        }
        if (personTong[''].indexOf(deyuArray[i].userid) == -1) {
          personTong[''].push(deyuArray[i].userid)
        }
      }

      var a = Object.keys(jibieTong[this.cType4])
      let huojiangCont = 0
      let huojiangPCont = personTong[this.cType4].length
      for (var i = 0; i < a.length; i++) {
        huojiangCont += jibieTong[this.cType4][a[i]]
      }
      this.deyuCont = huojiangCont
      this.deyuPCont = huojiangPCont

      this.personList = jibieTong[this.cType4]
      this.$forceUpdate();
    },
    typeChange() {

      this.$forceUpdate();
    },
    getData() {
      this.isLoading = true;
      let params = [
        {
          oid: this.oid,
          org: this.org,
        },
      ];
      this.ajax
        .post(this.$store.state.api + "selectDataBoardTest", params)
        .then((res) => {

          this.isLoading = false;
          let _cid1 = 'bf08fbbb-8a84-11ee-b98c-005056b86db5'; //个人发展规划
          let _cid2 = '90017320-8a9a-11ee-b98c-005056b86db5'; //教育观树
          let _cid3 = 'b578f126-89cd-11ee-b98c-005056b86db5'; //德育获奖
          let _cid4 = 'd47a6ab6-8a75-11ee-b98c-005056b86db5'; //教学获奖
          let _cid5 = '24c5e3b2-8a85-11ee-b98c-005056b86db5'; //校本培训心得
          let _cid6 = 'e9e6dc5a-89d1-11ee-b98c-005056b86db5'; //我的教学设计
          let classList = res.data[0] // 年级
          let subjectList = res.data[1] //学科
          this.classList = classList
          this.subjectList = subjectList

          this.teacherCount = res.data[2][0].count //教师总数
          this.testCount = res.data[3][0].count //评测总数
          this.submitPCount = res.data[4][0].count //提交人数
          this.submitCount = res.data[5][0].count //提交总数
          let submitArray = res.data[6].filter(item => item.worksCount >= 6)
          let submitArray2 = res.data[6].filter(item => item.worksCount > 0)
          this.subPersent = submitArray.length
          this.subPersent2 = submitArray2.length

          this.tedurArray = res.data[7]
          let xindeCount = 0
          res.data[7].forEach(element => {
            xindeCount += element.worksCount
          });

          this.xindeCount = xindeCount;

          let allTests = res.data[8]

          let shejiArray = allTests.filter(item => item.courseid == _cid6) // 我的教学设计



          let shejiJson = JSON.parse(shejiArray[0].chapters)
          let shejiTimeArray = shejiJson[0].array[1].json.array
          let shejiXuanArray = shejiJson[0].array[2].json.array
          let shejiTime = []
          let shejiXuan = []
          shejiTimeArray.forEach(el => {
            shejiTime.push(el.option)
          })
          shejiXuanArray.forEach(el => {
            shejiXuan.push(el.option)
          })

          this.shejiArray = shejiArray
          this.shejiTime = shejiTime
          this.shejiXuan = shejiXuan
          // this.cType = shejiTime[0]
          this.typeChange1()

          let guihuaArray = allTests.filter(item => item.courseid == _cid1) // 发展规划
          let guanshuArray = allTests.filter(item => item.courseid == _cid2) // 教育观树
          this.guihuaArray = guihuaArray
          this.guanshuArray = guanshuArray
          let huodongArray = [...guihuaArray, ...guanshuArray]
          let huodongJson = {}
          for (var i = 0; i < huodongArray.length; i++) {
            if (!huodongJson[huodongArray[i].userid]) {
              huodongJson[huodongArray[i].userid] = {
                name: huodongArray[i].username,
                guihua: 0,
                guanshu: 0
              }
            }
            if (huodongArray[i].courseid == _cid1) {
              huodongJson[huodongArray[i].userid].guihua++
            }
            if (huodongArray[i].courseid == _cid2) {
              huodongJson[huodongArray[i].userid].guanshu++
            }
          }
          this.workNumList = huodongJson

          let huojiangArray = allTests.filter(item => item.courseid == _cid4) // 教学获奖
          let huojiangJson = JSON.parse(huojiangArray[0].chapters)
          let huojiangTimeArray = huojiangJson[0].json.array
          let huojiangJibieArray = huojiangJson[2].json.array
          let huojiangMingciArray = huojiangJson[3].json.array
          let timeXuan = []
          let jibieXuan = []
          let mingciXuan = []
          huojiangTimeArray.forEach(el => {
            timeXuan.push(el.option)
          })
          huojiangJibieArray.forEach(el => {
            jibieXuan.push(el.option)
          })
          huojiangMingciArray.forEach(el => {
            mingciXuan.push(el.option)
          })

          this.huojiangArray = huojiangArray
          this.timeXuan = timeXuan
          this.jibieXuan = jibieXuan
          this.mingciXuan = mingciXuan
          // this.cType2 = timeXuan[0]
          // this.cType3 = timeXuan[0]
          this.typeChange2()
          this.typeChange3()


          let deyuArray = allTests.filter(item => item.courseid == _cid3) // 德育
          let deyuJson = JSON.parse(deyuArray[0].chapters)
          let deyuTimeArray = deyuJson[0].json.array
          let deyuJibieArray = deyuJson[3].json.array
          let deyuTimeXuan = []
          let deyuJibieXuan = []
          deyuTimeArray.forEach(el => {
            deyuTimeXuan.push(el.option)
          })
          deyuJibieArray.forEach(el => {
            deyuJibieXuan.push(el.option)
          })
          this.deyuArray = deyuArray
          this.deyuTimeXuan = deyuTimeXuan
          this.deyuJibieXuan = deyuJibieXuan
          // this.cType4 = deyuTimeXuan[0]
          this.typeChange4()
          this.$forceUpdate();
        })
        .catch((err) => {
          this.isLoading = false;
          this.$message.error('因加载数据量过大，服务器统计异常，请联系管理员。');
          console.error(err);
        });
    },
    checkArrayInclusion(arr1, arr2) {
      return arr1.every(item => arr2.includes(item));
    },
    hasCommonValue(arr1, arr2) {
      const set1 = new Set(arr1);
      for (const val of arr2) {
        if (set1.has(val)) {
          return true;
        }
      }
      return false;
    }
  },
};
</script>

<style scoped>
.body1 {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
}

.left {
  width: calc(100% / 3 * 1 - (20px / 3));
  height: 100%;
}

.left>.top {
  width: 100%;
  height: calc(100% / 2 - 5px);
  background: #fff;
  border-radius: 5px;
  margin: 0 0 10px 0;
}

.left>.bottom {
  width: 100%;
  height: calc(100% / 2 - 5px);
  background: #fff;
  border-radius: 5px;
}

.center {
  width: calc(100% / 3 - (20px / 3));
  height: 100%;
  margin: 0 10px;
}

.center>.top {
  width: 100%;
  height: calc(100% / 2 - 5px);
  background: #fff;
  border-radius: 5px;
  margin: 0 0 10px 0;
}

.center>.bottom {
  width: 100%;
  height: calc(100% / 2 - 5px);
  background: #fff;
  border-radius: 5px;
}

.right {
  width: calc(100% / 3 - (20px / 3));
  height: 100%;
}

.right>.top {
  width: 100%;
  height: calc(100% / 2 - 5px);
  background: #fff;
  border-radius: 16px;
  margin: 0 0 10px 0;
}

.right>.bottom {
  width: 100%;
  height: calc(100% / 2 - 5px);
  background: #fff;
  border-radius: 5px;
}

.titleBox {
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 15px;
  box-sizing: border-box;
  width: 100%;
}

.dataBox {
  height: calc(100% - 40px);
  width: 100%;
}

.middleBox {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-start;
}

.title {
  color: #060e17;
  margin-right: 10px;
}

.teaMiddle {
  width: calc(100% / 2 - 10px);
  height: 60px;
  border-radius: 8px;
  /* border: 1px solid #e0eafb; */
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 0 10px;
  margin: 0 10px;
}

.teaMiddle {
  width: calc(100% / 3 - 10px);
}

.cNum {
  background: linear-gradient(180deg,
      rgb(125, 227, 174, 0.2) 0%,
      rgb(23, 196, 105, 0.3) 100%) !important;
}

.tNum {
  background: linear-gradient(180deg,
      rgb(174, 204, 254, 0.2) 0%,
      rgb(54, 129, 252, 0.3) 100%) !important;
}

.tSum {
  background: linear-gradient(180deg,
      rgb(125, 227, 174, 0.2) 0%,
      rgb(23, 196, 105, 0.3) 100%) !important;
}

.teaLeft>div:first-child,
.teaMiddle>div:first-child {
  font-size: 12px;
  font-weight: 400;
  color: #565e6a;
}

.teaLeft>div:last-child,
.teaMiddle>div:last-child {
  font-size: 22px;
  font-weight: bold;
  color: #060e17;
}

.halfBox {
  width: 50%;
  height: 100%;
}

.selectBox {
  width: 80px;
  margin-left: 10px;
}

.selectBox>>>.el-input__inner {
  height: 30px;
  line-height: 30px;
}

.selectBox>>>.el-input__icon {
  line-height: 30px;
}

.timeDiv {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin: 0 0 0 15px;
}

.timeDiv>div {
  margin-right: 10px;
  cursor: pointer;
}

.isClick {
  color: #1684fc;
  border-bottom: 2px solid #1684fc;
  box-sizing: border-box;
}

.otherCss {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
}

.otherImg {
  width: 20px;
  height: 20px;
  margin: 0 10px;
  cursor: pointer;
}

.otherImg>img {
  width: 100%;
  height: 100%;
}

.allBox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
}

.allBox_left {
  width: 30%;
  height: 100%;
}

.allBox_right {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  width: 70%;
  margin: 0 auto;
  overflow: hidden;
  justify-content: space-between;
}

.depth {
  width: calc(100% / 4 - 10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.depth>span:nth-child(1) {
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 10px;
}

.depth>div:nth-child(1) {}

.info_box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  margin: 0 auto;
}

.info_box>.info2,
.info_box>.info3,
.info_box>.info {
  width: calc(50% - 10px);
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  margin-bottom: 10px;
  border-radius: 5px;
}

.info_box>.info2 {
  width: calc(100% / 4 - 10px);
  /* align-items: flex-end; */
}

.info_box>.info3 {
  width: 100%;
  margin-bottom: 5px;
}

.info_box>.info2>span:nth-child(1),
.info_box>.info3>span:nth-child(1),
.info_box>.info>span:nth-child(1) {
  font-size: 12px;
  /* margin: 0 0 0 20px; */
  color: #565e6a;
  width: 60px;
  white-space: pre-wrap;
  word-break: break-all;
}

.info_box>.info2>span:nth-child(2),
.info_box>.info3>span:nth-child(2),
.info_box>.info>span:nth-child(2) {
  font-size: 24px;
  /* font-weight: 700; */
}

.blueBG {
  background: rgb(243, 248, 253);
  border: 2px solid rgb(234, 246, 255);
}


.depth_box {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  width: 95%;
  margin: 0 auto;
  overflow: hidden;
  justify-content: space-between;
}

.depth {
  width: calc(100% / 2 - 10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.depth>span:nth-child(1) {
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 10px;
}

.depth>div:nth-child(1) {}</style>


// WEBPACK FOOTER //
// src/components/pages/dataBoardTest/course/index.vue